<template>
    <b-card>
        <b-row v-if="getProduct">
            <!-- Left Column: Product Images (6/6) -->
            <b-col cols="6">
                <div class="product-images-slider">
                    <swiper
                        :options="swiperOptions"
                        ref="mySwiper"
                    >
                        <swiper-slide
                            v-for="(image, index) in getProduct.images"
                            :key="index"
                            class="swiper-slide-image"
                        >
                            <img
                                :src="getImageUrl(image)"
                                :alt="`${getProduct.name} - Resim ${index + 1}`"
                                class="product-image"
                            />
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                </div>
            </b-col>

            <!-- Right Column: Product Information (6/6) -->
            <b-col cols="6">
                <div class="product-details">
                    <div class="d-flex justify-content-end mb-2">
                        <b-button variant="primary" @click="addToBasket(getProduct)">Sepete Ekle</b-button>
                    </div>

                    <!-- Merchant SKU -->
                    <div class="detail-item" v-if="searchedFbaProduct.az_product && searchedFbaProduct.az_product.merchant_sku">
                        <span class="detail-label">Asin:</span>
                        <span class="detail-value">{{ searchedFbaProduct.az_product.merchant_sku }}</span>
                    </div>

                    <!-- FN SKU -->
                    <div class="detail-item" v-if="searchedFbaProduct.fn_sku">
                        <span class="detail-label">FN SKU:</span>
                        <span class="detail-value">{{ searchedFbaProduct.fn_sku }}</span>
                    </div>

                    <!-- Seller SKU -->
                    <div class="detail-item" v-if="searchedFbaProduct.seller_sku">
                        <span class="detail-label">Amazon SKU:</span>
                        <span class="detail-value">{{ searchedFbaProduct.seller_sku }}</span>
                    </div>

                    <!-- Barcode -->
                    <div class="detail-item">
                        <span class="detail-label">Barkod:</span>
                        <span class="detail-value">{{ getProduct.barcode }}</span>
                    </div>


                    <!-- ID -->
                    <div class="detail-item">
                        <span class="detail-label">ID:</span>
                        <span class="detail-value">{{ getProduct.id }}</span>
                    </div>

                    <!-- Product Name -->
                    <div class="detail-item">
                        <span class="detail-label">Ürün Adı:</span>
                        <span class="detail-value">{{ getProduct.name }}</span>
                    </div>

                    
                    <!-- isBundle -->
                    <div class="detail-item">
                        <span class="detail-label">Takım:</span>
                        <span class="detail-value">{{ getProduct.isBundle === 1 ? 'Evet' : 'Hayır' }}</span>
                    </div>

                    <!-- Brand -->
                    <div class="detail-item" v-if="getProduct.brand">
                        <span class="detail-label">Marka:</span>
                        <span class="detail-value">{{ getProduct.brand.name }}</span>
                    </div>

                    
                    <!-- Fulfillable Quantity -->
                    <div class="detail-item" v-if="searchedFbaProduct.fulfillable_quantity !== null && searchedFbaProduct.fulfillable_quantity !== undefined">
                        <span class="detail-label">Fulfillable Quantity:</span>
                        <span class="detail-value">{{ searchedFbaProduct.fulfillable_quantity }}</span>
                    </div>

                    <!-- Total Quantity -->
                    <div class="detail-item" v-if="searchedFbaProduct.total_quantity !== null && searchedFbaProduct.total_quantity !== undefined">
                        <span class="detail-label">Total Quantity:</span>
                        <span class="detail-value">{{ searchedFbaProduct.total_quantity }}</span>
                    </div>

                    <!-- Marketplace Name -->
                    <div class="detail-item" v-if="searchedFbaProduct.store && searchedFbaProduct.store.marketplace_name">
                        <span class="detail-label">Marketplace:</span>
                        <span class="detail-value">{{ searchedFbaProduct.store.marketplace_name }}</span>
                    </div>

                </div>
            </b-col>
        </b-row>

        <div v-else class="text-center text-muted py-5">
            Ürün bilgisi bulunamadı
        </div>
    </b-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
    name: 'SearchedFbaProductComp',
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        searchedFbaProduct: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            swiperOptions: {
                slidesPerView: 1,
                spaceBetween: 30,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
        };
    },
    computed: {
        ...mapGetters('azFbaBasket', ['_searchedFbaProducts', '_productBarcode', '_search']),
        getProduct() {
            return this._searchedFbaProducts
                .flatMap(azFbaProduct => azFbaProduct.az_product?.products || [])
                .find(product => product.barcode === this._productBarcode) || null
        },
    },
    mounted() {
        if (this._searchedFbaProducts.length === 1 && this.getProduct) {
            this.addToBasket(this.getProduct);
        }
    },
    watch: {
        getProduct(newVal) {
            if (this._searchedFbaProducts.length === 1 && newVal) {
                this.addToBasket(newVal);
            }
        },
    },
    methods: {
        getImageUrl(image) {
            const apiPrefix = 'https://api.kitapfirsatlari.com/';
            if (typeof image === 'string') {
                return apiPrefix + image;
            }
            return apiPrefix + (image.url || '');
        },
        addToBasket(product) {
            const item = {
                product_id: product.id,
                az_product_id: this.searchedFbaProduct.az_product_id,
                az_store_fba_product_id: this.searchedFbaProduct.id,
                store_id: this.searchedFbaProduct.store_id,
                fn_sku: this.searchedFbaProduct.fn_sku,
                asin: this.searchedFbaProduct.az_product?.merchant_sku || '',
                barcode: this._productBarcode,
                basket_name: this._search.basketName,
                status: 'open',
                amount: 1
            };

            this.$store.dispatch('azFbaBasket/addBasket', item)
                .then(() => {
                    this.$bvToast.toast('Ürün sepete eklendi', {
                        title: 'Başarılı',
                        variant: 'success',
                        solid: true,
                    });
                })
                .catch(() => {
                    this.$bvToast.toast('Ürün sepete eklenirken bir hata oluştu', {
                        title: 'Hata',
                        variant: 'danger',
                        solid: true,
                    });
                });
        },
    },
};
</script>

<style scoped>
.product-images-slider {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.swiper-container-vertical {
    height: 100%;
    width: 100%;
}

.swiper-slide-image {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 450px;
}

.product-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.product-details {
    padding: 1rem;
    height: 100%;
}

.detail-item {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    gap: 0.5rem;
}

.detail-label {
    font-weight: 600;
    color: #333;
    font-size: 1.05rem;
    white-space: nowrap;
}

.detail-value {
    color: #666;
    font-size: 1rem;
    word-break: break-word;
}

.swiper-pagination {
    bottom: 10px;
    z-index: 10;
}

.swiper-button-prev,
.swiper-button-next {
    background-color: rgba(0, 0, 0, 0.3);
    color: white;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.swiper-button-prev:after,
.swiper-button-next:after {
    font-size: 16px;
}
</style>